<script context="module" lang="ts"></script>

<script lang="ts">
    import type { PanelData } from "./editor";

    export let panel: PanelData;
    export let drag: {
        start?: (event: PointerEvent) => void;
        move?: (event: PointerEvent) => void;
        end?: (event: PointerEvent) => void;
        cancel?: (event: PointerEvent) => void;
    } = {};

    const { scroll, header } = panel.templateOptions ?? {};
</script>

<!----------------------------------------------------------------------------->

{#if header?.enabled ?? true}
    <div class="header" on:pointerdown={drag.start} on:pointermove={drag.move} on:pointerup={drag.end} on:pointercancel={drag.cancel}>
        <span class="name">{panel.name}</span>

        {#if header?.component}
            <svelte:component this={header.component} {...header.props} />
            <!--{:else if header?.buttons}-->
            <!--    {#each header.buttons as button}-->
            <!--        <button on:click={button.action}>{button.name}</button>-->
            <!--    {/each}-->
        {/if}
    </div>
{/if}

{#if scroll}
    <!--TODO: Use overlay scrollbars-->
    <!--https://github.com/KingSora/OverlayScrollbars/tree/master/packages/overlayscrollbars-svelte-->
    <div class="scroll">
        <div class="content">
            <svelte:component this={panel.component} {...panel.props} />
        </div>
    </div>
{:else}
    <div class="content">
        <svelte:component this={panel.component} {...panel.props} />
    </div>
{/if}

<!----------------------------------------------------------------------------->
<style>
    .header {
        height: 2rem;
        display: flex;
        place-items: center;
        border-bottom: var(--gap-color) 1px solid;
        padding-left: 1em;
        user-select: none;
    }

    .header > .name {
        font-size: 1.1rem;
        flex-grow: 0;
        flex-basis: max-content;
    }

    .scroll {
        overflow-y: auto;
        /*overflow-x: hidden;*/
        scrollbar-width: thin;
        scrollbar-gutter: stable;
        /*scrollbar-color: cornflowerblue transparent;*/
        height: 100%;
    }

    .content {
        min-width: 100%;
        min-height: 100%;
        height: 100%;
        width: 100%;
    }
</style>
